import React from 'react';

/**
 * helper HOC to fetch the email if user has logged in
 * @param {Function} WrappedComponent
 * @return {Function}
 */
export const withEmail = (WrappedComponent) => {
    return class hoc extends React.Component {
        render() {
            const email = localStorage.getItem('email');
            return <WrappedComponent {...this.props} email={email}/>;
        }
    };
};
